import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20theater%20interior%20with%20dramatic%20red%20velvet%20curtains%20and%20gold%20accents%2C%20soft%20stage%20lighting%2C%20elegant%20atmosphere%2C%20warm%20amber%20and%20crimson%20tones%2C%20classic%20movie%20theater%20aesthetic%2C%20artistic%20composition%2C%20dark%20ambient%20background&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="九九免费视频 - 海量高清电影电视剧在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-sm text-white/90 font-medium">每日更新最新视频资源</span>
        </div>

        <h1 className="font-heading text-2xl md:text-5xl lg:text-6xl font-black text-white mb-4 leading-tight max-w-3xl">
          海量高清资源，
          <span className="text-accent-400">免费</span>
          畅享观影
        </h1>
        <p className="text-base md:text-lg text-white/70 mb-8 max-w-xl leading-relaxed">
          电影、电视剧、综艺、纪录片、动漫 — 全网热门内容，无需注册，即刻观看
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/dianying"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-base font-semibold whitespace-nowrap transition-all cursor-pointer hover:scale-105"
          >
            <i className="ri-play-circle-fill mr-2"></i>开始观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-full text-base font-medium whitespace-nowrap transition-all cursor-pointer border border-white/30"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center gap-6 md:gap-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-label font-bold text-white">10万+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">视频资源</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-label font-bold text-white">99%</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">高清画质</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-label font-bold text-white">0</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">注册门槛</div>
          </div>
        </div>
      </div>
    </section>
  );
}